import {createContext, use, useRef} from 'react';

import type {RefObject} from 'react';

type SleeveContainerContextType = {
  containerRef: RefObject<HTMLElement | null>;
};

const SleeveContainerContext = createContext<
  SleeveContainerContextType | undefined
>(undefined);

export function SleeveContainerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const containerRef = useRef<HTMLElement | null>(null);

  return (
    <SleeveContainerContext.Provider value={{containerRef}}>
      {children}
    </SleeveContainerContext.Provider>
  );
}

export function useSleeveContainer() {
  const context = use(SleeveContainerContext);
  if (!context) {
    throw new Error(
      'useSleeveContainer must be used within SleeveContainerProvider'
    );
  }
  return context;
}
